.scrollIcon {
  width: 19px;
}

.bookingCalendarElement {
  position: absolute;
  z-index: 5;
  left: 120px;
  border-style: solid;
  border-width: 1px;
  border-color: #e6e6e6;
}

.calendarElement {
  position: absolute;
  z-index: 1;
  right: 0;
  border-style: solid;
  border-width: 1px;
  border-color: #e6e6e6;
}

.calendarElement2 {
  border-style: solid;
  border-width: 1px;
  border-color: #e6e6e6;
  justify-self: flex-start;
}

.infoIcon {
  margin-left: auto;
}

.headerDropdown {
  width: 300px !important;
}

@media (min-width: 1620px) and (max-width: 1654px) {
  .scrollIcon {
    width: 15px;
  }
}

@media (min-width: 1553px) and (max-width: 1619px) {
  .scrollIcon {
    width: 12px;
  }

  .headerDropdown {
    width: 250px !important;
  }
}

@media (min-width: 1500px) and (max-width: 1552px) {
  .scrollIcon {
    width: 10px;
  }
}

@media (min-width: 1492px) and (max-width: 1499px) {
  .scrollIcon {
    width: 9px;
  }
}

@media (min-width: 1385px) and (max-width: 1491px) {
  .booking-font.css-u7857-MuiFormControl-root-MuiTextField-root .MuiOutlinedInput-input {
    font-size: 11px !important;
  }

  .headerDropdown {
    width: 220px !important;
  }
}

@media (min-width: 1300px) and (max-width: 1384px) {
  .booking-font.css-u7857-MuiFormControl-root-MuiTextField-root .MuiOutlinedInput-input {
    font-size: 10px !important;
  }

  .headerDropdown {
    width: 200px !important;
  }
}

@media (min-width: 1300px) and (max-width: 1491px) {
  .scrollIcon {
    width: 8px;
  }
}

@media (min-width: 1232px) and (max-width: 1299px) {
  .scrollIcon {
    width: 8px;
  }

  .booking-font.css-u7857-MuiFormControl-root-MuiTextField-root .MuiOutlinedInput-input {
    font-size: 9px !important;
  }

  .innerFilter {
    width: 220px;
    margin-left: 3px !important;
    padding-left: 7px !important;
    padding-right: 5px !important;
    padding-top: 0px !important;
    padding-bottom: 5px !important;
  }

  .headerDropdown {
    width: 180px !important;
  }
}

@media (min-width: 1170px) and (max-width: 1231px) {
  .scrollIcon {
    width: 8px;
  }

  .booking-font.css-u7857-MuiFormControl-root-MuiTextField-root .MuiOutlinedInput-input {
    font-size: 9px !important;
  }

  .innerFilter {
    width: 220px;
    margin-left: 3px !important;
    padding-left: 7px !important;
    padding-right: 5px !important;
    padding-top: 0px !important;
    padding-bottom: 5px !important;
  }

  .headerDropdown {
    width: 150px !important;
  }
}

@media (min-width: 1100px) and (max-width: 1169px) {
  .scrollIcon {
    width: 8px;
  }

  .innerFilter {
    margin-left: 0px !important;
    padding-left: 5px !important;
    padding-top: 0px !important;
    padding-bottom: 5px !important;
  }

  .headerDropdown {
    width: 120px !important;
  }
}

@media (min-width: 1000px) and (max-width: 1099px) {
  .scrollIcon {
    width: 8px;
  }

  .innerFilter {
    width: 200px;
    margin-left: 2px !important;
    padding-left: 5px !important;
    padding-right: 5px !important;
    padding-top: 0px !important;
    padding-bottom: 5px !important;
  }

  .headerDropdown {
    width: 120px !important;
  }
}

@media (min-width: 950px) and (max-width: 999px) {
  .scrollIcon {
    width: 8px;
  }
}

@media (min-width: 751px) and (max-width: 949px) {
  .scrollIcon {
    width: 8px;
  }
}

@media (min-width: 0px) and (max-width: 750px) {
  .scrollIcon {
    width: 8px;
  }
}
